// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__2qbhX","paragraph":"style_paragraph__2fwiD","links":"style_links__11eVP","row":"style_row__T099A"};